import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX, COUNTRIES, WARNING_MESSAGE_TYPES } from './constants'

import './style.scss'

export default class ImportContent extends Component {
    static propTypes = {
        importGroupMembers: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.state = {
            country: COUNTRIES.CZ,
            warningMessageType: null,
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown, true)
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown, true)
    }

    handleKeyDown = () => {
        if (this._pasteInput !== document.activeElement) {
            this._pasteInput.focus()
        }
    }

    handleOnRadioChange = (_e) => {
        const { country } = this.state

        if (_e.target.value !== country) {
            this.setState({ country: _e.target.value })
        }
    }

    handleOnPaste = (_e) => {
        const { importGroupMembers } = this.props
        const { country } = this.state
        const { BAD_IMPORT_TEXT, EMPTY_CONTAINER_TEXT } = WARNING_MESSAGE_TYPES

        const text = _e.clipboardData.getData('text')

        if (text) {
            const membersContainer = text.match(/\d+/g)
            const filteredMembers = membersContainer
                ? membersContainer.filter((member) => member.length <= 8)
                : membersContainer

            if (filteredMembers && filteredMembers.length > 0) {
                // really weird but isomorphic-fetch in IE11 fail in paste event handler => this fix works !!! (after 5h...)
                setTimeout(() => {
                    importGroupMembers(filteredMembers, country)
                }, 0)
            } else if (!membersContainer || membersContainer.length === 0) {
                this.setState({ warningMessageType: BAD_IMPORT_TEXT })
            } else if (filteredMembers && filteredMembers.length === 0) {
                this.setState({ warningMessageType: EMPTY_CONTAINER_TEXT })
            }
        }
    }

    render() {
        const { CZ, SK } = COUNTRIES
        const { warningMessageType } = this.state

        return (
            <div className={'members-import-content'}>
                <input className={'paste-input'} ref={(r) => (this._pasteInput = r)} onPaste={this.handleOnPaste} />
                <div className={'info-text'}>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.infoText`}
                        values={{ b: (chunks) => <b>{chunks}</b>, br: <br /> }}
                    />
                </div>
                <div className={'country-selection'}>
                    <input
                        type={'radio'}
                        id={'cs_radio'}
                        value={CZ}
                        checked={this.state.country === CZ}
                        onChange={this.handleOnRadioChange}
                    />
                    <label htmlFor={'cs_radio'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.csLabel`} />
                    </label>
                </div>
                <div className={'country-selection'}>
                    <input
                        type={'radio'}
                        id={'sk_radio'}
                        checked={this.state.country === SK}
                        value={SK}
                        onChange={this.handleOnRadioChange}
                    />
                    <label htmlFor={'sk_radio'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.skLabel`} />
                    </label>
                </div>
                {warningMessageType && (
                    <div className={'warning'}>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.${warningMessageType}`}
                            values={{ b: (chunks) => <b>{chunks}</b>, br: <br /> }}
                        />
                    </div>
                )}
            </div>
        )
    }
}
